import type { FC, ReactNode } from "react";

// 16px (size-4) composed icon: the Praetor avatar as the main identity marker
// with a small badge in the bottom-right corner indicating the action type
// (briefcase for "Add case", document for "Add from Praetor"). The badge is
// offset so the avatar 'P' remains visible as the primary visual.
export const PraetorComposedIcon: FC<{ overlay: ReactNode; alt?: string }> = ({ overlay, alt }) => (
  <span className="relative inline-flex size-4 shrink-0">
    <img
      src="/praetor-avatar.png"
      alt={alt ?? ""}
      className="size-4 rounded-sm object-cover"
    />
    <span className="absolute -bottom-[2px] -right-[2px] z-10 inline-flex size-[10px] items-center justify-center rounded-full bg-white text-foreground ring-[0.5px] ring-black/20 shadow-sm">
      {overlay}
    </span>
  </span>
);
